import React from "react"
import Heading from "./Heading"
import { Link } from "gatsby"

export default function DualInfoblock({ heading }) {
  return (
    <section className="my-4 py-4 bg-theme">
      <div className="container">
        <Heading title={heading} />
        <div className="row">
          <div className="col-8 mx-auto">
            <p className="lead text-white mb-5">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
              fringilla dignissim mattis. Nunc ut felis mauris. Nullam elit
              dolor, pharetra in fermentum at, varius nec nisl. Aenean varius
              molestie ligula, in malesuada nisi sodales id. Aliquam sit amet
              eros at urna faucibus feugiat. Ut nisi orci, fringilla a neque
              sed. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
              non aliquam quam. Curabitur a purus non nulla ullamcorper mattis
              vitae et quam. Donec libero neque, pharetra nec turpis et, rhoncus
              pulvinar purus. Aliquam semper molestie odio. Aenean fringilla in
              nisl ut dapibus. Praesent non dui eget odio porta posuere.
              Pellentesque habitant morbi tristique senectus et netus et
              malesuada fames ac turpis egestas. Donec odio libero, cursus eget
              aliquet vel, sollicitudin eu nibh. Sed vehicula et turpis a
              luctus. Nullam a tortor quis ex gravida commodo. Cras nulla risus,
              lobortis quis dictum in, congue nec sem. Curabitur semper, est non
              varius sollicitudin, magna ante tempus ligula, vitae egestas quam
              tortor ut lectus. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Aenean efficitur libero vel mauris consectetur,
              hendrerit feugiat tortor ornare. Praesent porttitor justo non
              convallis faucibus. Aenean sed enim a purus euismod varius et nec
              mauris. Orci varius natoque penatibus et.
            </p>
          </div>
          <div className="col-4">
            <div class="card bg-dark">
              <img
                src="https://images.pexels.com/photos/1144266/pexels-photo-1144266.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                class="card-img-top"
                alt="it goes here"
              />
              <div class="card-body">
                <h5 class="card-title text-success">Just clicked photos</h5>
                <p class="card-text text-white">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Aenean tristique, massa quis eleifend consequat, leo arcu
                  molestie felis, ac interdum enim arcu eget tellus. Vivamus
                  nisi nibh, viverra et tempor.
                </p>
                <Link to="/">
                  <button className="btn btn-warning btn-block">
                    {heading}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
